import React from 'react';
import { observer } from 'mobx-react-lite';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { KbSuggestionFieldWrapper } from './common/KbSuggestionFieldWrapper';
import { EditLongText } from './edit/EditLongText';
import { ViewLongText } from './view/ViewLongText';
export var LongText = observer(function (_ref) {
  var id = _ref.id,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditLongText, {
      id: id,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onChange: function onChange(event) {
        return questionStore.setAnswer(event.target.value);
      },
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    }), /*#__PURE__*/React.createElement(KbSuggestionFieldWrapper, {
      questionStore: questionStore
    }));
  }
  return /*#__PURE__*/React.createElement(ViewLongText, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
});